import React from 'react'
import {booking} from '@whyhotel/common-schema'

export interface CancellationPolicyProps {
  offer: booking.BookingOffer
}

const CancellationPolicy = ({offer}: CancellationPolicyProps) => {
  return (
    <div className="w-full">
      <h3 className="font-semibold text-base border-b mb-2">
        Cancellation Policy
      </h3>
      <p
        className="text-sm"
        dangerouslySetInnerHTML={{__html: offer?.cancellationFee?.description}}
      />
    </div>
  )
}

export default CancellationPolicy
